<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("invoices/getDetails", this.itemId);
    },
    computed: {
        totalAmount() {
            if (!this.invoice || !Array.isArray(this.invoice.services) || this.invoice.services.length === 0) {
                return 0;
            }
            var sum = 0;
            this.invoice.services.forEach(x => {
                sum += (x.discount > 0 && x.discount != null) ? (x.price - (x.price * (x.discount / 100))) : x.price;
            });
            if (this.invoice.discountType == 1 && this.invoice.discount != null) sum -= this.invoice.discount;
            else if (this.invoice.discountType == 2 && this.invoice.discount != null) sum -= sum * (this.invoice.discount / 100);
            return sum;

        },
        invoice() {
            return this.$store.state.invoices.invoice;
        }
    },
    data() {
        return {
            headersService: [
                { text: 'اسم الخدمة', value: 'serviceName' },
                // { text: 'الخدمة التفصلية', value: 'description' },
                { text: 'السعر ', value: 'price' },
                { text: 'التخفيض ', value: 'discount' },
                // { text: 'تاريخ  انتهاء الصلاحية ', value: 'expirationDate' },
            ],
            headers: [
                { text: 'اسم التحليل', value: 'analysisName' },
                { text: 'التصنيف', value: 'analysisGroup' },
                { text: 'السعر ', value: 'price' },
                // { text: 'تاريخ  انتهاء الصلاحية ', value: 'expirationDate' },
            ],
        };
    },
};
</script>